import { render, staticRenderFns } from "./addImageCanvas.vue?vue&type=template&id=6517e4d0"
import script from "./addImageCanvas.vue?vue&type=script&lang=js"
export * from "./addImageCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports